<template>
  <div class="box">
    <img class="closes" @click="closeHistory" src="../../assets/images/close.png" alt="">

    <div class="top" @click="backPage">

      <span>礼物记录</span>
    </div>
    <div class="noData" v-if="historyList.length<1">
      <img src="../../assets/images/gifts/noData.png" alt="">
      <span>暂无送出记录</span>
    </div>
    <div class="lists" v-else>
      <div v-for="(item,index) in historyList" :key="index" class="gift-list">
        <span>{{'给'+item.tname+'老师送出'}} <span class="txt">{{item.name}}</span></span>
        <span class="time">{{item.addt||''}}</span>
        <span class="number">x 1</span>
      </div>

    </div>


  </div>
</template>

<script>
import {GetGiveGiftList} from '../../api/home'
export default {
  name:'giftHistory',
 data(){
    return{
        historyList:[],
    
    }
 },
  created(){
    // 传给App.vue,不展示tabbar
    this.$emit('controlShow',true);
    this.getList()
  },
   computed:{
    // 个人信息
    userInfo() {
      return this.$store.state.login.userInfo
    },
  },
  methods:{
    closeHistory(){
      this.$store.commit('home/set_showhistory', false)


    },
    // 返回直播间
    backPage(){
        this.$router.push({
            name:'classRoomWap'
        })
    },
    // 获取礼物列表
    getList(){
     if(this.userInfo.id){
      GetGiveGiftList({
       page:0,
       size:20,
       platid:1,
       userid:this.userInfo.id
    }).then(res=>{
        console.log('礼物记录-------------',res)
        if(res.content.length>0){
          res.content.map(item=>{
            item.addt=this.getDateChange(item.addt)
          })
        }
        this.historyList = res.content
      })
     }else{
      this.historyList=[]
    }
    },
    // 时间戳转时间
    getDateChange(date) {
      var t = new Date(date).toLocaleString();
      return t;
    },
  }
}
</script>

<style lang="less" scoped>

  .box{
    width: 100%;

    background: #fff;

    height: 100%;
    position: relative;
    padding-top: 14px;
    .closes{
      position: absolute;
      top: 4%;
      right: 4%;
      width: 20px;
      height: 20px;
    }
    .top{
      height: 45px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    
      font-size: 16px;
      line-height: 25px;
      color: #000;
      font-weight: 700;
      text-align: center;
     
    }
    .gifts{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .lists{
      height: 300px;
      overflow-y: auto;
    }
    .gift-list{
        font-size: 13px;
        line-height: 18px;
        color: #333333;
        margin: 0 20px;
        padding: 14px 0;
        box-sizing: border-box;
        border-bottom: 1px solid #EEEEEE ;
        display: flex;
        flex-direction: column;
        position: relative;
        .txt{
            color: #FE2C55;
        }
        .time{
            color: #666666;
            font-size: 11px;
            line-height: 15px;
            margin-top: 8px;

        }
        .number{
            font-size: 16px;
            color: #FE2C55;
            font-weight: 600;
            position: absolute;
            bottom: 10px;
            right: 0;

        }
    }
    .noData{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        line-height: 20px;
        color: #999;
       img{
         width: 100px;
        height: 100px;
       }

    }
   
  }
</style>